import { createFilterAtoms } from '@/common/filtering/store.ts';
import {
  DEFAULT_TEMPLATE_FILTER,
  type TemplateFilterDefinition,
} from '@pac/filter/shared/templates';
import { resetTemplatePaginationOnFilterChangeAtom } from './pagination.ts';

export const templateFilterAtoms = createFilterAtoms<TemplateFilterDefinition>(
  DEFAULT_TEMPLATE_FILTER,
  resetTemplatePaginationOnFilterChangeAtom,
);
